function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { MenuItem } from 'prosemirror-menu';
import { toggleMark, setBlockType } from 'prosemirror-commands';
import { markActive } from '../utils';
export var cmdItem = function cmdItem(cmd, options) {
  var passedOptions = {
    label: options.title,
    run: cmd
  };
  Object.keys(options).reduce(function (acc, optionKey) {
    acc[optionKey] = options[optionKey];
    return acc;
  }, passedOptions);

  if ((!options.enable || options.enable === true) && !options.select) {
    passedOptions[options.enable ? 'enable' : 'select'] = function (state) {
      return cmd(state);
    };
  }

  return new MenuItem(passedOptions);
};
export var markItem = function markItem(markType, options) {
  var passedOptions = {
    active: function active(state) {
      return markActive(state, markType);
    },
    enable: true
  };
  Object.keys(options).reduce(function (acc, optionKey) {
    acc[optionKey] = options[optionKey];
    return acc;
  }, passedOptions);
  return cmdItem(toggleMark(markType), passedOptions);
};
export var blockTypeIsActive = function blockTypeIsActive(state, type, attrs) {
  var $from = state.selection.$from;
  var wrapperDepth;
  var currentDepth = $from.depth;

  var _loop = function _loop() {
    var currentNodeAtDepth = $from.node(currentDepth);

    var comparisonAttrs = _objectSpread({}, attrs);

    if (currentNodeAtDepth.attrs.level) {
      comparisonAttrs.level = currentNodeAtDepth.attrs.level;
    }

    var isType = type.name === currentNodeAtDepth.type.name;
    var hasAttrs = Object.keys(attrs).reduce(function (prev, curr) {
      if (attrs[curr] !== currentNodeAtDepth.attrs[curr]) {
        return false;
      }

      return prev;
    }, true);

    if (isType && hasAttrs) {
      wrapperDepth = currentDepth;
    }

    currentDepth -= 1;
  };

  while (currentDepth > 0) {
    _loop();
  }

  return wrapperDepth;
};
export var toggleBlockType = function toggleBlockType(type, attrs) {
  return function (state, dispatch) {
    var isActive = blockTypeIsActive(state, type, attrs);
    var newNodeType = isActive ? state.schema.nodes.paragraph : type;
    var setBlockFunction = setBlockType(newNodeType, attrs);
    return setBlockFunction(state, dispatch);
  };
};